import entities from "@/entities.yaml";
import localforage from "localforage";
import http from "@/services/http";
import {store} from "@/store";

const contextMap = {
  "organizationId": "organization",
  "year": "year",
  "organizationGroupId": "organizationsGroupId",
  "organizationsGroupId": "organizationsGroupId",
  "organizationGroupGuid": "organizationsGroupGuid",
  "organizationGuid": "organizationGuid",
  "budgetId": "budget",


  "organization": "organization",
  "orgId": "organization",
  "orgGroupId": "organizationsGroupId",
  "budget": "budget",
  "echelonType": "echelonType",
  "fieldId": "field",
  "childorganizationid": "childOrganizationId"
}

export function fetchEntities(list, callback = false) {
  if (list.length) {
    let params = {
      organizationId: store.getters["Contexts/getOrganization"],
      list: list.map(l => l.toLowerCase()),
      callback: () => {callback ? callback() : false},
    }
    manageQueue(params)
    getEntities(params)
  }
}
function manageQueue(params) {
  let queue = store.getters["EntityLoader/Queue/getQueue"].slice()
  queue[store.getters["EntityLoader/Queue/getQueueId"]] = params.list.length
  store.dispatch("EntityLoader/Queue/actionSetQueue", queue);
  store.dispatch("EntityLoader/Queue/actionSetQueueId", store.getters["EntityLoader/Queue/getQueueId"] + 1);
}
function getEntities(params) {
  params.list.forEach(entity => {
    const param = {...params, ...{name: entity, queueId: store.getters["EntityLoader/Queue/getQueueId"] - 1}}
    let foundEntity = findEntity(param.name);
    let path = getEntityPath(foundEntity, param);
    getRemoteData(path, param, foundEntity?.enums)
  })
}

function getRemoteData(path, params, hasCache) {
  let pathSplit = path.split("/")[0]
  if (pathSplit === "enums" || hasCache) {
    let status
    localforage.getItem("data/" + path).then(res => {
      if (res && res.data) {
        status = true
        store.dispatch("EntityLoader/actionAddEntity", {name: params.name, data: Object.freeze(res.data)})
        store.dispatch("EntityLoader/actionSetResponseStatus", {name: params.name, status: "success"})
      }
    })

    if (status) {
      return
    }
  }
  let dataVuex = fromVuex(params.name)
  if (dataVuex && dataVuex.length > 0) {
    store.dispatch("EntityLoader/actionSetResponseStatus", {name: params.name, status: "success"})
    updateFetchState(params)
    return
  }


  http.get(path).then(data => {
    if (pathSplit === "enums" || hasCache) {
      data = setEnumsKey(data)
    }
    store.dispatch("EntityLoader/actionAddEntity", {name: params.name, data: Object.freeze(data)})
    store.dispatch("EntityLoader/actionSetResponseStatus", {name: params.name, status: "success"})
    updateFetchState(params)
    localforage.setItem("data/" + path, {data: data})
  }).catch(() => {
    store.dispatch("EntityLoader/actionResetEntity", {name: params.name})
    store.dispatch("EntityLoader/actionSetResponseStatus", {name: params.name, status: "fail"})
    updateFetchState(params)
    localforage.removeItem("data/" + path)
  });
}

function setEnumsKey(data) {
  data.forEach(d => {
    d.key = d.id
    d.id = d.value
  })
  return data
}

function getEntityPath(foundEntity, params) {
  let cond = foundEntity && Object.prototype.hasOwnProperty.call(foundEntity, "path") && foundEntity.path.length
  let path = cond ? (foundEntity.path).toLowerCase() : params.name;
  const guidNames = {
    organizationId: "organizationGuid",
    organizationGroupId: "organizationGroupGuid",
    organizationsGroupId: "organizationGroupGuid",
    year: "year"
  }



  if (foundEntity && foundEntity.params) {
    foundEntity.params.map((name) => {
      path  = path + `/${store.getters["Contexts/getContexts"][contextMap[name]]}`
    })
  }
  if (foundEntity && foundEntity.contexts) {
    foundEntity.contexts.map((name, index) => {
      let key = foundEntity.guid ? guidNames[name] : name
      if (store.getters["Contexts/getContexts"][contextMap[key]]) {
        let value = store.getters["Contexts/getContexts"][contextMap[key]] || null
        path  = path + (index === 0 ? "?" : "&") + `${name}=${value}`
      }
      else if (name === "echelonType") {
        let value = "Harvesting"
        path  = path + (index === 0 ? "?" : "&") + `${name}=${value}`
      }
    })
  }

  return path
}

function updateFetchState(params) {
  let queue = store.getters["EntityLoader/Queue/getQueue"].slice()
  queue[params.queueId]--
  store.dispatch("EntityLoader/Queue/actionSetQueue", queue);
  resetQueue()
  if (!store.getters["EntityLoader/Queue/getQueue"][params.queueId]) {
    if (params.callback) params.callback();
  }
}




export function fromVuex(name, {getStatus = false} = {getStatus: false}) {
  if (getStatus) {
    let data = store.getters["EntityLoader/getEntity"](name);
    let status = store.getters["EntityLoader/getResponseStatus"](name);
    return [data, status]
  } else {
    return store.getters["EntityLoader/getEntity"](name);
  }
}

export function fromVuexDict(name, key = "id", {getStatus = false} = {getStatus: false}) {
  if (getStatus) {
    let data = store.getters["EntityLoader/getEntityObject"](name, key);
    let status = store.getters["EntityLoader/getResponseStatus"](name);
    return [data, status]
  } else {
    return store.getters["EntityLoader/getEntityObject"](name, key);
  }
}


function findEntity(entityName) {
  entityName = entityName.toString().toLowerCase();
  let key = Object.keys(entities).find(e => e.toLowerCase() === entityName)
  return key ? entities[key] : null
}

function resetQueue() {
  let empty = !store.getters["EntityLoader/Queue/getQueue"].reduce((sum, val) => sum += val, 0)
  if (empty) {
    store.dispatch("EntityLoader/Queue/actionSetQueue", []);
    store.dispatch("EntityLoader/Queue/actionSetQueueId", 0);
  }
}
